import { sortBy } from "underscore";
import { orderBy } from "lodash";
import { compareInstrument } from "../booking-instruments/booking-instruments-selected-context/BookingInstrumentsSelectedWrapper";

const isTimeGridClick = (event) => {
  const target = event?.domEvent?.target || event?.target;
  if (!target || typeof target.closest !== "function") {
    return null;
  }

  return !!target.closest(".mbsc-timegrid-cell, .mbsc-timegrid-item");
};

const toValidDate = (dateValue) => {
  const date = dateValue instanceof Date ? dateValue : new Date(dateValue);
  return Number.isNaN(date.getTime()) ? null : date;
};

const hasCustomTime = (dateValue) => {
  const date = toValidDate(dateValue);
  if (!date) return false;
  return date.getHours() !== 0 || date.getMinutes() !== 0;
};

export const groupReservationsByInstrument = (reservations, instruments) =>
  reservations
    .reduce((groups, reservation) => {
      let existingGroup = groups.find((group) => compareInstrument(group.instrument, reservation));

      if (!existingGroup) {
        existingGroup = {
          instrument: instruments.find((instrument) => compareInstrument(instrument, reservation)),
          reservations: [],
        };

        groups.push(existingGroup);
      }

      existingGroup.reservations.push(reservation);

      return groups;
    }, [])
    .map((group) => ({
      ...group,
      reservations: sortBy(group.reservations, (v) => v.dateFrom),
    }));

export const handleOnCellClick = (event, inst) => {
  setTimeout(() => {
    const val = inst?.getTempVal?.();
    if (!val || !val[0] || val[1] || inst?._activeSelect === "end") return;

    const timeGridClick = isTimeGridClick(event);

    // On datepicker onCellClick, switch to end only after explicit time-cell click.
    if (timeGridClick === true) {
      inst.setActiveDate("end");
      return;
    }

    if (timeGridClick === false) return;

    // Backward-compatible fallback for contexts using this helper via onTempChange.
    if (hasCustomTime(val[0])) {
      inst.setActiveDate("end");
    }
  }, 0);
};

export const sortedList = (items, fieldName, sortDirection = ["asc"]) => {
  return orderBy(items, [...fieldName], [...sortDirection]);
};
